import GuestI from '../interfaces/Guest';

const getModifiedStatus = (guest: GuestI, guestData: GuestI) =>
    Object.keys(guest).every((key) => guest[key] === guestData[key]);

export default getModifiedStatus;
